export const getLocalisedDate = (timestamp, short) => {
  return new Intl.DateTimeFormat('en-IN', { dateStyle: short ? 'medium' : 'long' }).format(new Date(timestamp)).replaceAll("-", " ");
};

export const getLocalisedTime = (timestamp, hour12, padStart, seconds) => {
  const time = new Date(timestamp).toLocaleString("en-US", { hour: "numeric", minute: "numeric", second: seconds ? "numeric" : undefined, hour12 });

  if (padStart) return time.padStart(8, 0);
  else return time;
};

export const isSameDay = (ts1, ts2) => {
  const day1 = new Date(ts1).getDate();
  const day2 = new Date(ts2).getDate();

  return (day1 === day2);
};

export const getDateStart = (ts = Date.now()) => {
  const date = new Date(ts);
  return date.setHours(0, 0, 0, 0);
};

export const getDateEnd = (ts = Date.now()) => {
  const date = new Date(ts);
  return date.setHours(23, 59, 59, 999);
};

export const getYearStart = (ts = Date.now()) => {
  const date = new Date(ts);
  return new Date(date.getFullYear(), 0, 1).getTime();
};

export const manipulateDate = (body, ts = Date.now()) => {
  let date = new Date(ts);

  if (body.year) date.setFullYear(date.getFullYear() + body.year);
  if (body.month) date.setMonth(date.getMonth() + body.month);
  if (body.weeks) {
    let dt = date.getTime();
    dt = dt + (body.weeks * (86400000 * 7)); // add or substract one week's ms
    date = new Date(dt);
  }
  if (body.days) date.setDate(date.getDate() + body.days);

  return date;
}

export const getISODate = (timestamp = Date.now()) => {
  const date = new Date(getDateStart(timestamp));

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, 0);
  const day = String(date.getDate()).padStart(2, 0);
  return `${year}-${month}-${day}`;
};

export const engMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const getDate = (timestamp, monthName, separator = " ", hideYear) => {
  let toyear, todate;
  todate = new Date(timestamp).getDate();
  if (!hideYear) toyear = new Date(timestamp).getFullYear();
  let a = new Date(timestamp).getMonth();
  let month = engMonthNames[a];

  let original_date = `${todate}${separator}${(monthName ? month : (a + 1))}${separator}${toyear || ""}`;
  return original_date;
};

export const secondsToHms = (seconds, getObject) => {
  seconds = Number(seconds);

  let h = Math.floor(seconds / 3600);
  let m = Math.floor(seconds % 3600 / 60);
  let s = Math.floor(seconds % 3600 % 60);

  if (getObject) return { h, m, s };

  let str = "";

  if (h && h < 10) h = "0" + h;
  if (m && m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;
  if (h > 0) str = h.toLocaleString() + "h ";
  if (m > 0 || h > 0) str = str + m + "m ";
  return str + s + "s";
}

export const stampToDate = (timestamp) =>{
  var todate = new Date(timestamp).getDate();
  // var tomonth = new Date(timestamp).getMonth()+1;
  var toyear = new Date(timestamp).getFullYear();
  var month = new Date(timestamp).getMonth();
  var monthName = engMonthNames[month];

  var original_date = todate + ' ' + monthName + ' ' + toyear;
  return original_date;
}

export const formatSecondsToHHMMSS = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

// 1734693444319 -> "4:47 PM"
export const formatTimestamp = (ts, showSecs) => {
  const date = new Date(Number(ts));
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedTime = showSecs ? `${hours}:${minutes}:${seconds} ${ampm}` : `${hours}:${minutes} ${ampm}`;
  return formattedTime;
};
